var map = {
	"./inner-360-factory-visibility.svg": 604,
	"./inner-automated-material-flow.svg": 605,
	"./inner-course-symb.svg": 606,
	"./inner-data-driven-maintenance.svg": 607,
	"./inner-digital-organization.svg": 608,
	"./inner-digital-ready-infrastructure.svg": 609,
	"./inner-fof-leadership.svg": 610,
	"./inner-intelligent-quality.svg": 611,
	"./inner-sustainability.svg": 612,
	"./inner-tech-augmented-workforce.svg": 613,
	"./inner-zero-touches-production.svg": 614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 288;